import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { i18nextFormat } from 'app/lib/datetime';

import en from '../../../public/locales/en/translation.json';
import kk from '../../../public/locales/kk/translation.json';
import ky from '../../../public/locales/ky/translation.json';
import ru from '../../../public/locales/ru/translation.json';
import uz from '../../../public/locales/uz/translation.json';
import { FALLBACK_LANG, SUPPORTED_LANGS } from '../constants';
import { getSupportedLang } from './supported-lang-functions';

// ---

const I18N_DEFAULT_INIT_OPTIONS = {
  partialBundledLanguages: true,
  ns: [],
  fallbackLng: FALLBACK_LANG,
  supportedLngs: SUPPORTED_LANGS,
  interpolation: {
    escapeValue: false,
    format: i18nextFormat,
  },
  react: { useSuspense: false },
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    uz: { translation: uz },
    kk: { translation: kk },
    ky: { translation: ky },
  },
};

export class LanguageStore {
  static instance: typeof i18n | null = null;

  static createInstance = (lang: string) => {
    if (LanguageStore.instance) {
      throw new Error('LanguageStore -> createInstance -> instance has already been created.');
    }

    const supportedLang = getSupportedLang(lang);

    // https://github.com/i18next/i18next/issues/1035
    // eslint-disable-next-line import/no-named-as-default-member
    LanguageStore.instance = i18n;

    return LanguageStore.instance.use(initReactI18next).init({
      ...I18N_DEFAULT_INIT_OPTIONS,
      lng: supportedLang,
    });
  };

  static getInstance = () => {
    if (!LanguageStore.instance) {
      throw new Error('LanguageStore -> getInstance -> instance not found.');
    }

    return LanguageStore.instance;
  };

  static getLang = () => {
    return getSupportedLang(LanguageStore.getInstance().language);
  };

  static changeLanguage = (lang: string) => {
    return LanguageStore.getInstance().changeLanguage(getSupportedLang(lang));
  };
}
